import React from "react";
import { Quiz } from "@domain/lms/quiz/quiz";
import { useMyQuizzesParticipants } from "@domain/user/hooks";
import { QuizParticipantModalList } from "./quizParticipantModalList";

interface QuizParticipantModalProps {
	quiz: Quiz;
	close: () => void;
}

export const QuizParticipantModal: React.FC<QuizParticipantModalProps> = ({ quiz, close }) => {
	const data = useMyQuizzesParticipants(quiz.id);
	return <QuizParticipantModalList data={data} close={close} quiz={quiz} />;
};
